import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { Popconfirm, Space, Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import moment from "moment";
import { getAnnouncementState } from "../../redux/store/getState";
import { Announcement } from "../../redux/apiSlice/announcementSlice";
import {
  deleteAnnouncement,
  getAnnouncements,
} from "../../redux/apiActions/announcementActions";
import { DeleteIcon } from "../../assets";
import { IconPrimary } from "../../components";
import AnnouncementForm from "../../forms/AnnoucementForm";
import useSearch from "../../hooks/useSearch";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const AnnoucementTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const { announcements, loading } = useAppSelector(getAnnouncementState);

  const [data, setData] = useState<Announcement[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  useSearch(announcements, setData);

  useEffect(() => {
    dispatch(getAnnouncements());
  }, [dispatch]);

  const columns: ColumnsType<Announcement> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Message",
      dataIndex: "message",
      width: "50%",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <AnnouncementForm record={record} />
          <Popconfirm
            title="Delete the announcement"
            description="Are you sure to delete the announcement?"
            onConfirm={() => dispatch(deleteAnnouncement(record.id))}
            okText="Yes"
            cancelText="No"
          >
            <IconPrimary>
              <DeleteIcon />
            </IconPrimary>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      // style={{ whiteSpace: "pre" }}
      loading={loading.getAnnouncement}
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      onChange={(p) =>
        setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
      }
      pagination={pagination}
      rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
    />
  );
};

export default AnnoucementTable;
